module.exports = __webpack_public_path__ + "static/img/ghost.33d62157.svg";